import React from 'react';


const Footer = () => {
    return (
        <footer className="footer text-center">
            {/* All Rights Reserved by Xtreme admin. Designed and Developed by{' '}
            <a href="https://wrappixel.com">WrapPixel</a>. */}
            Copyright © <a href="https://www.pyther.com/">Pyther Innovations Private Limited</a>
        </footer>
    );
}
export default Footer;
